import { Box, useTheme } from '@mui/material';
import { Button } from '@rumblefish/ui/Rumblefish23Theme';
import { useAnimation, motion } from 'framer-motion';
import { useEffect } from 'react';
import panenkaBannerImage from '../../../public/webp/fromPNG/portfolio/panenka-widget.webp';
import { animationVariant } from './PanenkaBanner.constants';
import { StyledTextWrapper, StyledText } from './PanenkaBanner.styles';
import type { PanenkaBannerProps } from './PanenkaBanner.types';
import { StaticImageData } from 'next/image';

export const PanenkaBanner = ({ show }: PanenkaBannerProps) => {
  const theme = useTheme();

  const control = useAnimation();

  useEffect(() => {
    if (show) {
      control.start('visible');
    } else {
      control.start('hidden');
    }
  }, [control, show]);

  return (
    <Box
      sx={{
        display: {
          xs: 'none',
          md: 'block',
        },
        position: 'fixed',
        right: theme.spacing(-3.5),
        top: '30%',
        width: 270,
        zIndex: 10,
      }}>
      <motion.div
        initial="hidden"
        animate={control}
        variants={animationVariant}
        transition={{ duration: 0.4 }}>
        <Box
          sx={{
            width: '100%',
            height: 300,
            backgroundImage: `url(${
              (panenkaBannerImage as unknown as StaticImageData)?.src
            })`,
            backgroundSize: 'contain',
            backgroundPosition: 'top',
            backgroundRepeat: 'no-repeat',
            paddingLeft: theme.spacing(6.5),
            paddingBottom: theme.spacing(3),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}>
          <StyledTextWrapper variant="top">
            <StyledText>See synthetic data</StyledText>
          </StyledTextWrapper>
          <StyledTextWrapper variant="bottom">
            <StyledText>generation in action!</StyledText>
          </StyledTextWrapper>

          <Button
            link="/case-studies/panenka"
            sx={{
              mt: 2,
              '& .MuiStack-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.55) !important',
                border: `1px solid ${theme.palette.greenColors?.PLUS_1}`,
                paddingInline: theme.spacing(1.5),
                paddingBlock: theme.spacing(0),
              },
              '& .MuiTypography-root': {
                fontSize: 10,
              },
            }}>
            Read the case study
          </Button>
        </Box>
      </motion.div>
    </Box>
  );
};
